<template>
  <div class="header">
    <div class="overform" v-if="form">
      <div class="form">
        <div class="input-field">
          <input type="text" placeholder="Name" />
        </div>
        <div class="input-field">
          <input type="text" placeholder="Email" />
        </div>
        <div class="input-field">
          <input type="text" placeholder="Phone" />
        </div>
        <div class="input-field">
          <textarea placeholder="Message"></textarea>
        </div>
        <button>Submit</button>
      </div>
      <button @click="form = false">Close</button>
    </div>
    <div class="topbar">
      <div class="info">
        <p>info@rubiifitness.com</p>
        <p>+91 9225063549</p>
      </div>
      <div class="logo">
        <img src="../assets/logo.png" alt="logo" />
      </div>
      <div class="socials">
        <p>Follow us on</p>
        <div class="icons">
          <a href="https://facebook.com/" target="_blank">
            <i class="bx bxl-facebook"></i>
          </a>
          <a href="https://instagram.com/" target="_blank">
            <i class="bx bxl-instagram"></i>
          </a>
          <!-- linkedin -->
          <a href="https://linkedin.com/" target="_blank">
            <i class="bx bxl-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/about">About Us</router-link>
        </li>
        <li>
          <router-link to="/services">Our Services</router-link>
        </li>
        <li>
          <router-link to="/products">Our Products</router-link>
        </li>
        <!-- Why Us -->
        <li>
          <router-link to="/whyus">Why Us</router-link>
        </li>
        <li>
          <router-link to="/contact">Contact Us</router-link>
        </li>
        <!-- Book An Appointment -->
        <li>
          <router-link to="" class="red" @click="form = true"
            >Book An Appointment</router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "headerComponent",
  data() {
    return {
      form: false,
    };
  },

  mounted() {
    // hide topbar on scroll

    let topbar = document.querySelector(".topbar");

    // let previousscrollpos = 0;

    window.addEventListener("scroll", () => {
      console.log(window.scrollY);
      if (window.scrollY > 0) {
        topbar.style.display = "none";
      } else {
        topbar.style.display = "flex";
      }

      // //   show nav on scrolling up
      // let currentscrollpos = window.scrollY;
      // if (previousscrollpos > currentscrollpos) {
      //   topbar.style.display = "flex";
      // }
      // previousscrollpos = currentscrollpos;
    });
  },
};
</script>

<style scoped>
.overform {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overform .form {
  width: 50%;
  height: 50%;
  background: white;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.overform .form .input-field {
  width: 100%;
  height: 3rem;
  margin-bottom: 1rem;
}

.overform .form .input-field input,
.overform .form .input-field textarea {
  width: 100%;
  height: 100%;
  border: 1px solid var(--border);
  outline: none;
  padding: 0 1rem;
  font-size: 1rem;
  font-weight: 400;
  color: var(--text);
}

.overform .form .input-field textarea {
  resize: none;
}

.overform .form button {
  width: 50%;
  height: 3rem;
  border: none;
  outline: none;
  background: var(--red);
  color: white;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
}

.overform button {
  width: 50%;
  height: 3rem;
  border: none;
  outline: none;
  background: var(--red);
  color: white;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
}

.overform button:hover {
  background: var(--red-hover);
}

.overform .form button:hover {
  background: var(--red-hover);
}

.header {
  width: 100%;
  margin: 0;
  padding: 0 5%;
  z-index: 999;
  position: sticky;
  top: 0;
  left: 0;
  height: auto;
  background-color: white;
}

.header .topbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header .topbar .info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 15%;
}

.header .topbar .info p {
  font-size: 1rem;
  font-weight: 400;
  color: var(--text);
  margin-bottom: 0.5rem;
}

.header .topbar .logo {
  width: 70%;
  height: 8rem;
  padding: 1rem 0;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .topbar .logo img {
  width: auto;
  height: 70%;
}

.header .topbar .socials {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 15%;
}

.header .topbar .socials p {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--text);
  margin-bottom: 0.5rem;
}

.header .topbar .socials .icons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 70%;
}

.header .topbar .socials .icons a {
  text-decoration: none;
  font-size: 1rem;
  color: white;
  transition: all 0.3s ease;
  background: var(--red);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .topbar .socials .icons a:hover {
  background: var(--grey);
  color: var(--text);
}

.header nav {
  width: 100%;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header nav ul {
  width: 85%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  height: fit-content;
}

.header nav ul li {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
  height: fit-content;
}

.header nav ul li a {
  text-decoration: none;
  color: var(--text);
  transition: all 0.3s ease;
  padding: 0.5rem 0;
}

.header nav ul li a:hover {
  color: var(--red);
}

a.red {
  color: var(--red) !important;
}

@media screen and (max-width: 768px) {
  .header {
    display: none;
  }
}
</style>
